import { render, staticRenderFns } from "./SingleCoupon.vue?vue&type=template&id=94bff8f2&scoped=true&"
import script from "./SingleCoupon.vue?vue&type=script&lang=js&"
export * from "./SingleCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bff8f2",
  null
  
)

export default component.exports